import React from "react";
import DiscogsFetcher from "../components/DiscogsFetcher/DiscogsFetcher";
import ListingForm from "../components/ListingForm/ListingForm";
import RawDiscogsView from "../components/RawDiscogsView/RawDiscogsView";
import ItemConditionToggle from "../components/ItemConditionToggle/ItemConditionToggle";
import { useDiscogsForm } from "../hooks/useDiscogsForm";
import { getApiUrl } from "../lib/api";

const SingleListing = () => {
  const {
    formData,
    setFormData,
    discogsRelease,
    handleDiscogsData,
    handleItemConditionChange,
  } = useDiscogsForm();

  const handleSubmitToEbay = async () => {
    try {
      const payload = { ...formData };

      const res = await fetch(getApiUrl("/api/ebay/listing"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // ✅ Required for sending cookies
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        alert("✅ Listing scheduled! Check your eBay Scheduled tab.");
        console.log("🧾 eBay Listing Response:", data);
      } else {
        alert("❌ eBay listing failed. Check the console.");
        console.error("🚨 eBay error:", data.error || data);
      }
    } catch (err) {
      alert("🔥 Request error. Check console.");
      console.error("❗ Fetch error:", err);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-10 text-white">
      <h1 className="text-3xl font-bold mb-8 text-center">
        Drop Groove: eBay Listing Tool
      </h1>

      <div className="bg-zinc-900 border border-zinc-700 rounded-2xl shadow-xl p-6 mb-10">
        <DiscogsFetcher onFetch={handleDiscogsData} />

        <div className="mt-6">
          <ItemConditionToggle
            value={formData.itemCondition}
            onChange={handleItemConditionChange}
          />
        </div>

        <div className="mt-6">
          <ListingForm formData={formData} setFormData={setFormData} />
        </div>

        {discogsRelease && (
          <div className="mt-6">
            <RawDiscogsView discogsRelease={discogsRelease} />
          </div>
        )}

        <div className="pt-6 text-center">
          <button
            onClick={handleSubmitToEbay}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition"
          >
            Submit to eBay
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleListing;
